import { render, staticRenderFns } from "./PostalCodeFormDialog.vue?vue&type=template&id=75b82c5d&"
import script from "./PostalCodeFormDialog.vue?vue&type=script&lang=js&"
export * from "./PostalCodeFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports